import classNames from 'classnames'

import { useFilesPreviewGalleryLifecycle } from './FilesPreviewGallery.hooks'
import { FilesPreviewGalleryContent } from './FilesPreviewGalleryContent'

import * as styles from './FilesPreviewGallery.module.css'

/**
 * - scope
 * scope values: 'mail', 'flat', 'user', 'request_thread', 'request_activity', 'request', 'request_chat', 'tree', 'building', 'post'
 *- subject
 * it's a subject id (object_id) ex: request_id, activity_id ...etc
 */
function FilesPreviewGallery({
  className = styles.FilesPreviewGallery,
  downloadFileDocument,
  files,
  getFileById,
  initActive,
  scope = null,
  subject = null,
  onClose,
}) {
  const {
    handleAnimationEnd,
    handleClickBackdrop,
    handleClose,
    isExiting,
    isOpen,
  } = useFilesPreviewGalleryLifecycle({ initActive, onClose })

  if (!isOpen) {
    return null
  }

  const galleryClassName = classNames(className, {
    [styles.closing]: isExiting,
  })

  return (
    <div
      className={galleryClassName}
      onAnimationEnd={handleAnimationEnd}
      onClick={handleClickBackdrop}
    >
      <FilesPreviewGalleryContent
        downloadFileDocument={downloadFileDocument}
        files={files}
        getFileById={getFileById}
        initActive={initActive}
        key={initActive}
        scope={scope}
        subject={subject}
        onClose={handleClose}
      />
    </div>
  )
}

export default FilesPreviewGallery
